import { create } from 'zustand';
import { createJSONStorage, persist } from 'zustand/middleware';

type PostponedConsentsState = {
    postponedCompanies: Record<string, boolean>;
    setPostponed: (companyId: string, isPostponed: boolean) => void;
    isPostponed: (companyId: string) => boolean;
    clearPostponed: (companyId: string) => void;
    clearAllPostponed: () => void;
};

export const useConsentStore = create<PostponedConsentsState>()(
    persist(
        (set, get) => ({
            postponedCompanies: {},
            setPostponed: (companyId: string, isPostponed: boolean) =>
                set((state) => ({
                    postponedCompanies: {
                        ...state.postponedCompanies,
                        [companyId]: isPostponed
                    }
                })),
            isPostponed: (companyId: string) => {
                return get().postponedCompanies[companyId] === true;
            },
            clearPostponed: (companyId: string) =>
                set((state) => {
                    const newPostponedCompanies = {
                        ...state.postponedCompanies
                    };
                    delete newPostponedCompanies[companyId];
                    return { postponedCompanies: newPostponedCompanies };
                }),
            clearAllPostponed: () => set({ postponedCompanies: {} })
        }),
        {
            name: 'instapaid-consent-store',
            storage: createJSONStorage(() => localStorage)
        }
    )
);
